import {
  handleDeleteResponse,
  handleError,
  handleGetResponse,
  handlePatchResponse,
  handlePostResponse,
} from '../utils/handleResponse'
import Token from '../utils/Token'

import * as types from '../constants/ActionTypes'

export const fetchDns = () => (dispatch) => (
  fetch('/edge/api/system/network/dns', {
    headers: {
      'X-Jwt-Token': Token.get(),
    },
  })
    .then((resp) => handleGetResponse(resp))
    .then((json) => dispatch({
      type: types.NETWORK_DNS,
      dns: json,
    }))
    .catch((e) => handleError(e, dispatch))
)

export const fetchPoe = () => (dispatch) => (
  fetch('/edge/api/system/network/poe', {
    headers: {
      'X-Jwt-Token': Token.get(),
    },
  })
    .then((resp) => handleGetResponse(resp))
    .then((json) => dispatch({
      type: types.NETWORK_POE,
      poe: json,
    }))
    .catch((e) => handleError(e, dispatch))
)

export const fetchSwitch = () => (dispatch) => (
  fetch('/edge/api/system/network/switch', {
    headers: {
      'X-Jwt-Token': Token.get(),
    },
  })
    .then((resp) => handleGetResponse(resp))
    .then((json) => dispatch({
      type: types.NETWORK_SWITCH,
      switch: json,
    }))
    .catch((e) => handleError(e, dispatch))
)

export const fetchConnection = () => (dispatch) => (
  fetch('/edge/api/system/network/connections', {
    headers: { 'X-Jwt-Token': Token.get() },
  })
    .then((resp) => handleGetResponse(resp))
    .then((json) => dispatch({
      type: types.NETWORK_CONNECTION,
      connections: json.connections,
    }))
    .catch((e) => handleError(e, dispatch))
)

export const fetchConnectionHwinfo = (name) => async (dispatch) => {
  const resp = await fetch(`/edge/api/system/network/connections/${name}/hwinfo`, {
    headers: { 'X-Jwt-Token': Token.get() },
  })
  const json = await resp.json()
  return dispatch({
    type: types.NETWORK_HWINFO,
    name,
    hwinfo: json,
  })
}

export const fetchConnectionRoutes = (name) => async (dispatch) => {
  const resp = await fetch(`/edge/api/system/network/connections/${name}/routes`, {
    headers: { 'X-Jwt-Token': Token.get() },
  })
  const json = await resp.json()
  return dispatch({
    type: types.NETWORK_ROUTES,
    name,
    routes: json,
  })
}

export const updateDns = (values) => (dispatch) => (
  fetch('/edge/api/system/network/dns', {
    method: 'POST',
    headers: {
      'X-Jwt-Token': Token.get(),
    },
    body: JSON.stringify({
      automatic: values.automatic,
      servers: [values.preferred, values.server1, values.server2],
    }),
  })
    .then((resp) => handlePostResponse(resp, dispatch, fetchDns))
    .catch((e) => handleError(e, dispatch))
)

export const fetchModems = () => (dispatch) => (
  fetch('/edge/api/system/network/modems', {
    headers: { 'X-Jwt-Token': Token.get() },
  })
    .then((resp) => handleGetResponse(resp))
    .then((json) => dispatch({
      type: types.NETWORK_MODEMS,
      modems: json,
    }))
    .catch((e) => handleError(e, dispatch))
)

export const fetchSIM = (simID) => (dispatch) => (
  fetch(`/edge/api/system/network/modems/sim${simID}`, {
    headers: { 'X-Jwt-Token': Token.get() },
  })
    .then((resp) => handleGetResponse(resp))
    .then((json) => dispatch({
      type: types.NETWORK_MODEM_SIM,
      simID,
      sim: json,
    }))
    .catch((e) => handleError(e, dispatch))
);

export const factoryResetModem = (modemID, resetCode) => (dispatch) => (
  fetch(`/edge/api/system/network/modems/mdm${modemID}/factory-reset`, {
    method: 'POST',
    headers: { 'X-Jwt-Token': Token.get() },
    body: JSON.stringify({ resetCode }),
  })
    .then((resp) => handlePostResponse(resp, dispatch, fetchModems))
    .catch((e) => handleError(e, dispatch))
);

export const resetModem = (modemID) => (dispatch) => (
  fetch(`/edge/api/system/network/modems/mdm${modemID}/reset`, {
    method: 'POST',
    headers: { 'X-Jwt-Token': Token.get() },
    body: JSON.stringify({}),
  })
    .then((resp) => handlePostResponse(resp, dispatch, fetchModems))
    .catch((e) => handleError(e, dispatch))
);

export const updateHostname = (values) => (dispatch) => (
  fetch('/edge/api/system/network/dns', {
    method: 'POST',
    headers: {
      'X-Jwt-Token': Token.get(),
    },
    body: JSON.stringify({ hostname: values.hostname }),
  })
    .then((resp) => handlePostResponse(resp, dispatch, fetchDns))
    .catch((e) => handleError(e, dispatch))
);

export const disablePinSIM = (simID, pin) => (dispatch) => (
  fetch(`/edge/api/system/network/modems/sim${simID}/pin-disable`, {
    method: 'POST',
    headers: { 'X-Jwt-Token': Token.get() },
    body: JSON.stringify({
      passkey: pin,
    }),
  })
    .then((resp) => handlePostResponse(resp, dispatch, () => fetchSIM(simID)))
    .catch((e) => handleError(e, dispatch))
);

export const enablePinSIM = (simID, pin, _, remember) => (dispatch) => (
  fetch(`/edge/api/system/network/modems/sim${simID}/pin-enable`, {
    method: 'POST',
    headers: { 'X-Jwt-Token': Token.get() },
    body: JSON.stringify({
      passkey: pin,
      remember,
    }),
  })
    .then((resp) => handlePostResponse(resp, dispatch, () => fetchSIM(simID)))
    .catch((e) => handleError(e, dispatch))
);

export const unlockSIM = (simID, pin, puk, remember) => (dispatch) => (
  fetch(`/edge/api/system/network/modems/sim${simID}/pin-unlock`, {
    method: 'POST',
    headers: { 'X-Jwt-Token': Token.get() },
    body: JSON.stringify({
      passkey: pin,
      carrierCode: puk,
      remember,
    }),
  })
    .then((resp) => handlePostResponse(resp, dispatch, () => fetchSIM(simID)))
    .catch((e) => handleError(e, dispatch))
);

export const updatePinSIM = (simID, oldPin, newPin, remember) => (dispatch) => (
  fetch(`/edge/api/system/network/modems/sim${simID}/pin-change`, {
    method: 'POST',
    headers: { 'X-Jwt-Token': Token.get() },
    body: JSON.stringify({
      passkey: oldPin,
      newPasskey: newPin,
      remember,
    }),
  })
    .then((resp) => handlePostResponse(resp, dispatch, () => fetchSIM(simID)))
    .catch((e) => handleError(e, dispatch))
);
export const updatePoe = (values) => (dispatch) => {
  const ports = []
  Object.keys(values).sort().forEach((key) => {
    const { powermode, budget } = values[key]
    ports.push({
      power: powermode === 'auto' || powermode === 'manual',
      budget: powermode === 'auto' ? 0 : budget,
    })
  })

  return fetch('/edge/api/system/network/poe', {
    method: 'POST',
    headers: {
      'X-Jwt-Token': Token.get(),
    },
    body: JSON.stringify({ ports }),
  })
    .then((resp) => handlePostResponse(resp, dispatch, fetchPoe, fetchSwitch))
    .catch((e) => handleError(e, dispatch))
}

function prepareAdvanced(advanced) {
  if (!advanced) {
    return {};
  }

  const { metric, ...rest } = advanced;

  return {
    metric: Number(metric),
    ...rest,
  };
}

function prepareBond(bond) {
  if (!bond) {
    return {};
  }

  return { ...bond };
}

function prepareVlan(vlan) {
  if (!vlan) {
    return {};
  }

  const { vlanID, ...rest } = vlan;

  return {
    vlanID: Number(vlanID),
    ...rest,
  };
}

export const updateConnection = (values) => (dispatch) => {
  // map from
  // {
  //   "name": "enx",
  //   "label": "link0",
  //   ...
  // }
  // back to connection object
  // {
  //   "enx": { ... }
  // }
  const {
    advanced, bond, dns, ip, vlan,
  } = values;
  const { label, name, ...rest } = ip;

  const body = {
    ...rest,
    ...dns,
    ...prepareAdvanced(advanced),
    ...prepareBond(bond),
    ...prepareVlan(vlan),
  }

  return fetch('/edge/api/system/network/connections', {
    method: 'POST',
    headers: { 'X-Jwt-Token': Token.get() },
    body: JSON.stringify({
      connections: {
        [name]: body,
      },
    }),
  })
    .then((resp) => handlePostResponse(resp, dispatch, fetchConnection))
    .catch((e) => handleError(e, dispatch))
}

export const identifyConnection = (name, identify) => async (dispatch) => {
  const resp = await fetch(`/edge/api/system/network/connections/${name}/identify`, {
    method: 'POST',
    headers: { 'X-Jwt-Token': Token.get() },
    body: JSON.stringify({ identify }),
  })
  const json = await resp.json()
  return dispatch({
    type: types.NETWORK_IDENTIFY,
    name,
    isBlinking: json.identify,
  })
}

export const createConnection = (values) => (dispatch) => (
  fetch('/edge/api/system/network/connections', {
    method: 'PUT',
    headers: { 'X-Jwt-Token': Token.get() },
    body: JSON.stringify({ ...values }),
  })
    .then((resp) => handlePostResponse(resp, dispatch, fetchConnection))
    .catch((e) => handleError(e, dispatch))
)

export const deleteConnection = (id) => (dispatch) => (
  fetch(`/edge/api/system/network/connections/${id}`, {
    method: 'DELETE',
    headers: { 'X-Jwt-Token': Token.get() },
  })
    .then((resp) => handleDeleteResponse(resp, dispatch, fetchConnection))
    .catch((e) => handleError(e, dispatch))
)

export const updateModemSettings = (request) => (dispatch) => {
  const { modems } = request;

  // Modem settings updates go to individual modem endpoints using PATCH
  const modemPromises = [];
  if (modems && Object.keys(modems).length > 0) {
    // Send PATCH requests to individual modem endpoints
    Object.entries(modems).forEach(([modemID, settings]) => {
      const modemPromise = fetch(`/edge/api/system/network/modems/mdm${modemID}`, {
        method: 'PATCH',
        headers: {
          'X-Jwt-Token': Token.get(),
        },
        body: JSON.stringify({
          modem: settings,
        }),
      }).then((resp) => handlePatchResponse(resp, dispatch, fetchModems))
        .catch((error) => {
          throw error;
        });

      modemPromises.push(modemPromise);
    });
  }

  // Wait for all modem updates to complete
  return Promise.all(modemPromises)
    .catch((e) => handleError(e, dispatch));
};

export const fetchCameraNetwork = () => (dispatch) => (
  fetch('/edge/api/system/camera-network', {
    headers: { 'X-Jwt-Token': Token.get() },
  })
    .then((resp) => handleGetResponse(resp))
    .then((json) => dispatch({
      type: types.NETWORK_CAMERA_NETWORK,
      cameraNetwork: json,
    }))
    .catch((e) => handleError(e, dispatch))
)

export const updateCameraNetwork = (values) => (dispatch) => (
  fetch('/edge/api/system/camera-network', {
    method: 'POST',
    headers: { 'X-Jwt-Token': Token.get() },
    body: JSON.stringify(values),
  })
    .then((resp) => handlePostResponse(resp, dispatch, fetchCameraNetwork))
    .catch((e) => handleError(e, dispatch))
)
